import { useTranslation } from 'react-i18next';

import {
  checkHouseNext,
  checkPassNext,
  getHtm062,
  setHouseChkAfterCalc,
} from '../features/common/commonSlice';
import {
  checkNoPaperCertify,
  getPDFUploadInfo,
  setCalc,
} from '../features/resultQuery/resultQuerySlice';
import { useDispatch } from 'react-redux';
import Typography from '../components/common/Typography';
import { relationOptions } from './data';

//alert전역함수
let alertMessageFunction = null;

export const setAlertMessageFunction = func => {
  alertMessageFunction = func;
};

export const getAlertMessageFunction = () => {
  return alertMessageFunction;
};

/**
 * 폼 데이터 trim 처리
 * @param {Object} data - 원본 데이터
 * @returns {Object} trim 처리된 데이터
 */
export const trimFormData = data => {
  if (!data) return {};

  const trimmedData = {};
  Object.keys(data).forEach(key => {
    const value = data[key];
    if (value === undefined || value === null) {
      trimmedData[key] = '';
    } else {
      trimmedData[key] = String(value).trim();
    }
  });
  return trimmedData;
};

//마감체크
export const magamCertifyCheck = (isMagam, isCertify) => {
  const alertMessage = getAlertMessageFunction();
  if (isMagam) {
    alertMessage('연말정산이 마감되어 수정이 불가능합니다');
    return false;
  }

  if (isCertify) {
    alertMessage('신고서 제출이 완료되어 수정이 불가능합니다.');
    return false;
  }

  return true;
};

//기존 PC에서 처리하던 방식
export const checkHouseNextFunction01 = async (
  dispatch,
  t,
  navigate,
  nextPath,
  isMagam,
  isCertify,
) => {
  const alertMessage = getAlertMessageFunction();
  const response = await dispatch(checkHouseNext()).unwrap();
  const { resultCode } = response;
  if (resultCode === '1') {
    //필요한 전자문서를 전부 제출~~
    alertMessage(t('checkHouseNext.alertMessage01'));
    return;
  }
  if (resultCode === '2') {
    //주택자금 공제요건 체크(필수)를 완료~~~
    alertMessage(t('checkHouseNext.alertMessage02'));
    return;
  }

  //마감, 인증한 사람 아니면
  if (resultCode === '3' && !isMagam && !isCertify) {
    //전액공제 확인
    const passResponse = await dispatch(checkPassNext()).unwrap();
    const { resultCode: passResultCode } = passResponse;
    if (passResultCode == '-1') {
      //세액계산
      const calcResponse = await dispatch(setCalc()).unwrap();
      //결정세액 확인
      if (calcResponse.resultCode == '1') {
        const htm062Response = await dispatch(getHtm062()).unwrap();
        const { resultCode: htm062ResultCode } = htm062Response;
        if (htm062ResultCode == '0') {
          //전액환급자 -> 결과조회
          alertMessage(t('checkHouseNext.alertMessage03'));
          navigate('/resultQuery');
          return;
        }
      }
    }
  }

  navigate(nextPath);
};

//기존 앱에서 처리하던 방식
export const checkHouseNextFunction = async (
  dispatch,
  t,
  navigate,
  nextPath,
  isMagam,
  isCertify,
) => {
  const alertMessage = getAlertMessageFunction();
  const response = await dispatch(setHouseChkAfterCalc()).unwrap();
  const {
    resultCode,
    resultData: { flag, firstMove },
  } = response;

  //마감이나 인증한 사람이면 넘어가기
  if (isMagam || isCertify) {
    navigate(nextPath);
    return;
  }
  //flag 1:전액공제자, 2:전액공제자아님, 3:주택자금 공제요건 미완료, 4:PDF미업로드
  // 1:공제요건체크 다 함, 2:공제요건체크 해야됨
  if (resultCode === '1') {
    if (flag == '3') {
      //주택자금 공제요건 체크(필수)를 완료~~~
      alertMessage(t('checkHouseNext.alertMessage02'));
      return;
    }

    if (flag === '4') {
      //필요한 전자문서를 전부 제출~~
      alertMessage(t('checkHouseNext.alertMessage01'));
      navigate('/eDocuments');

      // dispatch(getFullRefundDialogConfig(t));
      return;
    }

    if (flag === '1' && firstMove == '2') {
      //전액환급자 -> 결과조회
      // alertMessage(t('checkHouseNext.alertMessage03'));
      // navigate('/resultQuery');
      dispatch(getFullRefundDialogConfig(t));
      return;
    }
  }

  //전부 통과되면 안전빵으로 getPDFUploadInfo 한번더 태운다(위에는 상세 안올린 걸 판단할 수 없기 때문)
  const isRequiredFiles = await checkedRequiredFiles(dispatch, t, navigate);
  if (isRequiredFiles) {
    navigate(nextPath);
  }
};

export const checkedRequiredFiles = async (dispatch, t, navigate) => {
  try {
    //전자문서 파일 올렸는지 여부
    const alertMessage = getAlertMessageFunction();
    const resultPDFUploadInfo = await dispatch(getPDFUploadInfo()).unwrap();
    if (resultPDFUploadInfo.resultCode == '1') {
      //필요한 증빙서류
      // noPaperCertify(dispatch, t, navigate);
    } else {
      if (resultPDFUploadInfo.resultCode == '2') {
        //필요한 통합
        alertMessage(t('pdfUpload.alertMessage2'));
        return false;
      }
      if (resultPDFUploadInfo.resultCode == '3' || resultPDFUploadInfo.resultCode == '5') {
        //필요한 상세
        alertMessage(t('pdfUpload.alertMessage3'));
        return false;
      }
      if (resultPDFUploadInfo.resultCode == '4') {
        //전자문서(PDF) 파일을 업로드 해주세요.
        alertMessage(t('pdfUpload.alertMessage4'));
        return false;
      }
    }
    return true;
  } catch (error) {
    console.log(error);
  }
};

const noPaperCertify = async (dispatch, t, navigate) => {
  try {
    const alertMessage = getAlertMessageFunction();
    const result = await dispatch(checkNoPaperCertify()).unwrap();
    const { resultCode } = result;
    if (resultCode === '0') {
      //필요한 증빙서류~~
      alertMessage(t('alertMessage1'));
      navigate('/evidenceDocuments');
      return;
    }
  } catch (error) {
    console.error('Error fetching data:', error);
  }
};

//rejected 처리 (state 초기화)
export const handleRejected = (state, action, resetFields) => {
  state.status = 'failed';
  // state.error = action?.error?.message;
  resetFields.forEach(field => {
    if (Array.isArray(state[field])) {
      state[field] = [];
    } else {
      state[field] = '';
    }
  });
};

//연말정산 연도 반환
export const getCurrentYear = () => {
  //테스트라 -1 쓴거임 실제로 -1 지워야해!!!!!!
  // return new Date().getFullYear() ;
  // return new Date().getFullYear() - 1;
  //여기를 String으로 해야 === 할때 에러가 안나요
  return '2025';
};

//메인화면 알림 메세지 파싱
export const msgParser = res => {
  const messageMap = [
    { key: 'htm001', type: '부양가족' },
    { key: 'htm002', type: '보험료' },
    { key: 'htm003', type: '의료비' },
    { key: 'htm004', type: '주택자금' },
    { key: 'htm005', type: '기부금' },
    { key: 'htm006', type: '연금저축' },
    { key: 'htm007', type: '소기업' },
    { key: 'htm008', type: '혼이장' },
    { key: 'htm009', type: '연금공제' },
    { key: 'htm010', type: '주택마련저축' },
    { key: 'htm011', type: '투자조합' },
    { key: 'htm012', type: '신용카드' },
    { key: 'htm013', type: '우리사주' },
    { key: 'htm014', type: '장기주식저축' },
    { key: 'htm015', type: '세액공제' },
    { key: 'htm016', type: '전직장' },
    { key: 'htm017', type: '교육비' },
    { key: 'htm099', type: '기타메시지' },
  ];
  let resultMessage = [];
  messageMap.map(obj => {
    if (res[obj.key]) {
      const data = res[obj.key];
      //console.log(obj.type, data);
      const sp = data.split('\r\n');

      let rows = [];
      if (sp.length > 0) {
        sp.map(res => {
          rows.push(res);
        });
        resultMessage.push({
          title: obj.type,
          rows: rows,
        });
      }
    }
  });
  return resultMessage;
};

// null 값을 빈 문자열로 변환하는 함수
export const sanitizeList = list => {
  return list.map(item => {
    const sanitizedItem = {};
    Object.keys(item).forEach(key => {
      sanitizedItem[key] = item[key] === null ? '' : item[key]?.trim();
    });
    return sanitizedItem;
  });
};

export const handleFulfilled = (state, action) => {
  // const {}

  state.status = 'succeeded';
  state.data = action.payload;
};

export const maskId = id => {
  const halfLength = Math.floor(id.length / 2);
  const maskedPart = id.substring(0, halfLength);

  return maskedPart.padEnd(10, '*');
};

export const formatPhoneNumber = phoneNumber => {
  if (phoneNumber == undefined || phoneNumber == null) {
    return '';
  } else {
    if (phoneNumber.length === 11) {
      return (
        phoneNumber.slice(0, 3) + '-' + phoneNumber.slice(3, 7) + '-' + phoneNumber.slice(7, 11)
      );
    } else {
      return phoneNumber;
    }
  }
};

export const fixNullString = (args, change) => {
  if (args == undefined || args == null) {
    return change;
  } else {
    return args.toString();
  }
};

export const formatDate = date => {
  if (date == undefined || date == null || date === '') {
    return '';
  } else {
    return date.slice(0, 4) + '-' + date.slice(4, 6) + '-' + date.slice(6, 8);
  }
};

export const formatNumber = number => {
  /**
   * 숫자를 천 단위로 콤마(,)를 찍어서 반환하는 함수
   * null, undefined, 또는 빈 문자열 입력 시 안전하게 처리
   * @param {number|string} number - 포맷팅할 숫자 또는 숫자 문자열
   * @returns {string} - 천 단위로 콤마가 찍힌 문자열
   */
  if (number === null || number === undefined || number === '') {
    return '0';
  }

  // 문자열이나 숫자가 아닌 입력값 처리
  const num = Number(number);
  if (isNaN(num)) {
    return '0';
  }

  // 천 단위 콤마 처리
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

//formatNumber 함수 사용시 콤마 제거, '0'제거 후 숫자값만 전달
export const handleNumberChange = (value, onChange) => {
  const rawValue = value.replace(/,/g, '');
  // 빈 값이거나 0인 경우 처리
  if (!rawValue || rawValue === '0') {
    onChange('');
    return;
  }
  // 앞의 불필요한 0 제거 후 숫자값만 전달
  const cleanedValue = rawValue.replace(/^0+/, '') || '0';
  onChange(cleanedValue);
};

export const handleNumberChange2 = (value, onChange) => {
  // 숫자가 아닌 문자와 콤마 제거
  const rawValue = value.replace(/[^0-9,]/g, '').replace(/,/g, '');
  // 빈 값이거나 0인 경우 처리
  if (!rawValue || rawValue === '0') {
    return '';
  }
  // 앞의 불필요한 0 제거 후 숫자값만 전달
  const cleanedValue = rawValue.replace(/^0+/, '') || '0';
  return cleanedValue;
};

// 시간을 MM:SS 형식으로 변환하는 함수
export const formatTime = seconds => {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  return `${String(minutes).padStart(2, '0')}:${String(remainingSeconds).padStart(2, '0')}`;
};

export const truncateString = (str, maxLength) => {
  /**
   * 문자열을 주어진 길이로 자르고 초과할 경우 "..."을 붙여 반환하는 함수
   * null, undefined, 또는 빈 문자열 입력 시 안전하게 처리
   * @param {string} str - 원본 문자열
   * @param {number} maxLength - 최대 길이
   * @returns {string} - 길이를 초과하면 "..."이 붙은 문자열, 그렇지 않으면 원본 문자열
   */
  if (str == null || str === '') {
    return '';
  }

  str = String(str); // 문자열이 아닌 입력값을 문자열로 변환

  if (str.length > maxLength) {
    return str.slice(0, maxLength) + '...';
  }
  return str;
};

export const getPath = (str, depth = 1, full = false) => {
  if (full) {
    let pathSplit = str.split('/');
    let pathdep = '';
    for (let i = 1; i < depth + 1; i++) {
      pathdep = pathdep + '/' + pathSplit[i];
    }
    return pathdep;
  } else {
    let pathSplit = str.split('/');
    let path1dep = '/' + pathSplit[depth];

    return path1dep;
  }
};

export const keyGen = () => {
  const chars = 'abcdefghijklmnopqrstuvwxyz1234567890';
  const rand = (min = 0, max = 1000) => Math.floor(Math.random() * (max - min) + min);

  const randchars = [];
  for (let i = 0; i < 8; i++) {
    randchars.push(chars[rand(0, chars.length)]);
  }

  return randchars.join('');
};

export const getDate = unixTime => {
  let a = new Date(unixTime * 1000);
  let year = a.getFullYear();
  let month = a.getMonth() + 1;
  let date = a.getDate();
  let time = year + '-' + month + '-' + date;

  // console.log('formattedTime', time);
  return time;
};

export const getDateTime = unixTime => {
  let a = new Date(unixTime * 1000);

  let year = a.getFullYear();
  let month = a.getMonth() + 1;
  let date = a.getDate();
  let hour = a.getHours();
  let min = a.getMinutes();
  let sec = a.getSeconds();
  //let time = year + '-' + month + '-' + date + ' ' + hour + ':' + min + ':' + sec;
  let time = year + '-' + month + '-' + date + ' ' + hour + ':' + min;

  // console.log('formattedTime', time);
  return time;
};

export const getTotal = (list, keys = null) => {
  return list.reduce((acc, obj) => {
    let objectTotal = 0;

    if (Array.isArray(keys)) {
      // 지정된 키만 합산
      keys.forEach(key => {
        if (obj.hasOwnProperty(key)) {
          objectTotal += Number(obj[key]) || 0;
        }
      });
    } else {
      // 모든 키 합산
      Object.values(obj).forEach(value => {
        objectTotal += Number(value) || 0;
      });
    }

    return acc + objectTotal;
  }, 0);
};

export const getPathDepth = str => {
  let pathSplit = str.split('/');
  // console.log(pathSplit);
  // console.log(pathSplit[pathSplit.length - 1]);
  if (pathSplit[pathSplit.length - 1] === '') {
    return pathSplit.length - 2;
  }
  return pathSplit.length - 1;
};

export const getAge = (birthData, sexFlag, currentYear) => {
  if (!birthData || birthData.length < 6) {
    console.error('유효하지 않은 birthData입니다.');
    return null;
  }

  // 주민번호에서 생년월일 추출
  const yearPart = parseInt(birthData.slice(0, 2), 10);

  let fullYear;

  // sexFlag를 기반으로 생년 계산
  switch (sexFlag) {
    case '1':
    case '2':
      fullYear = 1900 + yearPart;
      break;
    case '3':
    case '4':
      fullYear = 2000 + yearPart;
      break;
    case '5':
    case '6':
      fullYear = 1900 + yearPart;
      break;
    case '7':
    case '8':
      fullYear = 2000 + yearPart;
      break;
    case '0':
    case '9':
      fullYear = 1800 + yearPart;
      break;
    default:
      console.error('유효하지 않은 sexFlag입니다.');
      return null;
  }

  let age = Number(currentYear) - fullYear;

  return age;
};

// 주민번호 앞자리 추출
export const getRegNumber08 = regNumber => {
  if (regNumber == null || regNumber == '') {
    return '';
  }

  if (regNumber.length != 13) {
    return '';
  }

  let year = '';
  let sexFlag = regNumber.substr(6, 1);

  if (sexFlag == '3' || sexFlag == '4' || sexFlag == '7' || sexFlag == '8') {
    year = '20';
  } else {
    year = '19';
  }

  return year + regNumber.slice(0, 6);
};

export const setRegNumber = regNumber => {
  if (!regNumber) {
    return '';
  }
  const cleanedNumber = regNumber.replace(/[^0-9]/g, '');

  if (cleanedNumber.length <= 6) {
    return cleanedNumber;
  }

  return cleanedNumber.substring(0, 6) + '-' + cleanedNumber.substring(6, 13);
};

export const isCheckHouseHolder = regNumber => {
  if (regNumber == null || regNumber == '') {
    return false;
  }

  var index = regNumber.indexOf('-');

  if (index <= 0 || index + 1 >= regNumber.length) {
    return false;
  }

  var value = regNumber.charAt(index + 1);
  return value >= 5 && value <= 8;
};

//사업자 또는 주민번호 검증
export const checkRegistrationNumber = input => {
  const { t } = useTranslation();
  const number = input.replace(/[^0-9]/g, '');
  const result = {};

  if (number === '') {
    result.chk = true;
  } else if (number.length === 13) {
    // 주민등록번호 검증
    result.chk = checkResidentRegistrationNumber(number);
    result.error = t('residentNumberMessage1');
  } else if (number.length === 10) {
    // 사업자번호 검증
    result.chk = checkCompanyRegistrationNumber(number);
    result.error = t('residentNumberMessage1');
  } else {
    // 유효하지 않은 번호 길이
    result.chk = false;
    result.error = t('residentNumberMessage2');
  }

  return result;
};

// 날짜 검증
export const isValidDate = param => {
  try {
    param = param.replace(/-/g, '');

    // 자리수가 맞지않을때
    if (isNaN(param) || param.length != 8) {
      return false;
    }

    var year = Number(param.substring(0, 4));
    var month = Number(param.substring(4, 6));
    var day = Number(param.substring(6, 8));

    var dd = day / 0;

    if (month < 1 || month > 12) {
      return false;
    }

    var maxDaysInMonth = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    var maxDay = maxDaysInMonth[month - 1];

    // 윤년 체크
    if (month == 2 && ((year % 4 == 0 && year % 100 != 0) || year % 400 == 0)) {
      maxDay = 29;
    }

    if (day <= 0 || day > maxDay) {
      return false;
    }
    return true;
  } catch (err) {
    return false;
  }
};

// 주민등록번호 검증 함수
export const checkResidentRegistrationNumber = number => {
  const perNo = number.replace('-', '');
  const formulaNo = '234567892345';
  let total = 0;

  for (let i = 0; i < 12; i++) {
    total += parseInt(perNo.charAt(i), 10) * parseInt(formulaNo.charAt(i), 10);
  }

  total = 11 - (total % 11);
  if (total === 10) total = 0;
  else if (total === 11) total = 1;

  return total === parseInt(perNo.charAt(12), 10);
};

//전액환급
export const getFullRefundDialogConfig = (t, slice, actionPayload) => {
  return {
    type: 'dialog/openSlideUp',
    payload: {
      // title: t('fullRefundDialog.title'),
      // description: t('fullRefundDialog.description'),
      // slice: slice,
      // actionPayload: actionPayload
      slice: 'fullRefund',
      // innertComponent: (
      //   <div
      //     className="displayFlexColumn"
      //     style={{ gap: '30px', alignItems: 'center', paddingBottom: '30px' }}>
      //     <img src={fullrefund_img} alt="ant_img" />
      //     <div className="displayFlexColumn" style={{ gap: '8px', alignItems: 'center' }}>
      //       <Typography className="subtitleBold">{t('fullRefundDialog.title')}</Typography>
      //       <Typography>{t('fullRefundDialog.description')}</Typography>
      //     </div>
      //   </div>
      // ),
      actionType: 'FULL_REFUND',
      buttons: [
        {
          label: t('fullRefundDialog.button1'),
          // onClick: () => {
          //   navigate('/resultQuery');
          // },
        },
      ],
    },
  };
};

// customDialogConfig
export const getDialogConfig = (t, customKey, slice, actionType, actionPayload) => {
  console.log('getDialogConfig', customKey, slice, actionPayload);
  return {
    type: 'dialog/openSlideUp',
    payload: {
      title: t(customKey + '.title'),
      description: t(customKey + '.description'),
      slice: slice,
      actionPayload: actionPayload,
      actionType: actionType,
      buttons: [
        {
          label: t(customKey + '.button1'),
        },
        {
          label: t(customKey + '.button2'),
          color: 'secondary',
        },
      ],
    },
  };
};

// 삭제 다이얼로그 설정
export const getDeleteDialogConfig = (t, slice, actionPayload) => {
  return {
    type: 'dialog/openSlideUp',
    payload: {
      title: t('deleteDialog.title'),
      description: t('deleteDialog.description'),
      slice: slice,
      actionPayload: actionPayload,
      actionType: 'DELETE',
      buttons: [
        {
          label: t('deleteDialog.button1'),
        },
        {
          label: t('deleteDialog.button2'),
          color: 'secondary',
        },
      ],
    },
  };
};

// 취소 다이얼로그 설정
export const getCancelDialogConfig = (t, slice, actionPayload) => ({
  type: 'dialog/openSlideUp',
  payload: {
    title: t('cancelDialog.title'),
    description: t('cancelDialog.description'),
    actionType: 'CANCEL',
    slice: slice,
    actionPayload: actionPayload,
    buttons: [
      {
        label: t('cancelDialog.button1'),
      },
      {
        label: t('cancelDialog.button2'),
        color: 'secondary',
      },
    ],
  },
});

export const getAutoSaveDialogConfig = (t, slice, actionPayload) => ({
  type: 'dialog/openSlideUp',
  payload: {
    title: t('autoLogin.title'),
    description: t('autoLogin.description'),
    actionType: 'AUTO_SAVE',
    slice: slice,
    actionPayload: actionPayload,
    buttons: [
      {
        label: t('autoLogin.button1'),
        style: { flex: 1 },
        color: 'secondary',
      },
      {
        label: t('autoLogin.button2'),
        style: { flex: 1 },
      },
    ],
    buttonStyle: {
      justifyContent: 'space-between',
      flexDirection: 'row',
    },
  },
});

export const nameRelation = (t, data) => {
  //t : dependents
  let relationList = relationOptions(t);

  if (!data) return '';

  if (!data?.htm038 || !data?.htm002) return '';

  //관계없으면 이름만 return
  if (!data?.htm002) return `${data?.htm038 || ''}`;

  return `${data?.htm038 || ''} (${
    relationList.find(option => option.value === data?.htm002)?.label || ''
  })`;
};

export const getMobileOS = () => {
  try {
    // 앱에서 실행 중인 경우
    if (window?.ReactNativeWebView) {
      // userAgent를 사용하여 플랫폼 감지
      const userAgent = window.navigator.userAgent.toLowerCase();
      if (/iphone|ipad|ipod/.test(userAgent)) {
        return 'ios';
      } else if (/android/.test(userAgent)) {
        return 'android';
      }
      return 'other';
    }

    // 웹브라우저에서 실행 중인 경우
    const userAgent = window.navigator.userAgent.toLowerCase();
    if (/iphone|ipad|ipod/.test(userAgent)) {
      return 'ios';
    } else if (/android/.test(userAgent)) {
      return 'android';
    }

    return 'other';
  } catch (error) {
    console.error('플랫폼 감지 실패:', error);
    return 'other';
  }
};

//사업자번호 검증
export const checkCompanyRegistrationNumber = number => {
  let numberMap = number
    .replace(/-/gi, '')
    .split('')
    .map(function (d) {
      return parseInt(d, 10);
    });

  if (numberMap.length == 10) {
    let keyArr = [1, 3, 7, 1, 3, 7, 1, 3, 5];
    let chk = 0;

    keyArr.forEach(function (d, i) {
      chk += d * numberMap[i];
    });

    chk += parseInt((keyArr[8] * numberMap[8]) / 10, 10);
    return Math.floor(numberMap[9]) === (10 - (chk % 10)) % 10;
  }
  return false;
};

export const viewerConfig = {
  preset: 'inline',
  extraPlugins: ['pasteCode'],
  //toolbar: true,d
  // autofocus: true,
  readonly: true,
  // license: 'A01BM-2/862-CTOML-RAL6Y', // localhost용
  license: '174FE-0Q6K0-CDLNP-L11RZ', // developers.payday.co.kr
  placeholder: '컨텐츠를 입력하세요.',
};

/**
 * 파일 데이터에서 이미지 리스트 생성
 * @param {Array} fileData - 파일 데이터 배열
 * @returns {Array} 페이지별로 분리된 이미지 리스트
 */
export const generateImageListFromFileData = fileData => {
  const resultFileList = [];
  if (!fileData || fileData.length === 0) return resultFileList;

  fileData.forEach(files => {
    const pageCount = parseInt(files.page) || 0;
    if (pageCount > 0) {
      [...Array(pageCount)].forEach((_, fileNum) =>
        resultFileList.push({
          ...files,
          pageNum: fileNum + 1,
        }),
      );
    }
  });

  return resultFileList;
};

// 날짜 범위 체크 (YYYYMMDD 형식)
export const isDateInRange = (startDate, endDate) => {
  if (!startDate || !endDate) return false;
  const today = new Date();
  const todayStr =
    today.getFullYear().toString() +
    (today.getMonth() + 1).toString().padStart(2, '0') +
    today.getDate().toString().padStart(2, '0');
  return todayStr >= startDate && todayStr <= endDate;
};
